// src/pages/Home.js
import React from 'react';
import Products from '../components/Products';
import Features from '../components/Features';
import PaymentMethods from '../components/PaymentMethods';
import Brands from '../components/Brands';
import CustomersCounter from '../components/CustomersCounter';
import ContactDetails from '../components/ContactDetails';
import Maps from '../components/Maps';
import Hero from '../components/Hero';



const Home = ({showToast}) => {
    return (
        <div className="home-page">
            <Hero />
            <Products showToast={showToast} />
            <Features />
            <PaymentMethods />
            <Brands />
            <CustomersCounter />
            <ContactDetails />
            <Maps />
        </div>
    );
};

export default Home;